(() => {
  const script = document.currentScript;
  if (!(script instanceof HTMLScriptElement) || document.documentElement.dataset.mamAccountLoginBound) return;
  const accountUrl = new URL(script.dataset.shiprocketAccountUrl, location.origin);
  if (accountUrl.origin !== location.origin || !script.dataset.shiprocketAccountUrl) return;
  document.documentElement.dataset.mamAccountLoginBound = 'true';
  const selector = 'a[href], [data-mam-account-login], .shiprocket-login-link, .shiprocket-login-btn';
  const explicit = '[data-mam-account-login], .shiprocket-login-link, .shiprocket-login-btn';
  const key = url => url.origin + url.pathname.replace(/\/$/, '');
  const nativeRoutes = new Set([script.dataset.nativeLoginUrl, script.dataset.nativeAccountUrl, script.dataset.storefrontLoginUrl]
    .filter(Boolean).map(value => key(new URL(value, location.origin))));
  let launching = false, timer, loading, launchVersion = 0, pageActive = true;
  window.mamLoadShiprocket = () => {
    if (typeof window.shipRocketMarketingLogin === 'function') return Promise.resolve();
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      const loginScript = document.createElement('script');
      let settled = false;
      const timeout = setTimeout(() => finish(new Error('Shiprocket login timed out')), 15000);
      function finish(error) {
        if (settled) return;
        settled = true;
        clearTimeout(timeout);
        loginScript.onload = loginScript.onerror = null;
        if (error) {
          loginScript.remove();
          reject(error);
        } else resolve();
      }
      loginScript.src = script.dataset.shiprocketLoginSrc;
      loginScript.async = true;
      loginScript.onload = () => finish(typeof window.shipRocketMarketingLogin === 'function' ? null : new Error('Shiprocket login unavailable'));
      loginScript.onerror = () => finish(new Error('Shiprocket login failed to load'));
      document.head.appendChild(loginScript);
    }).catch(error => {
      loading = null;
      throw error;
    });
    return loading;
  };
  async function launch() {
    const version = ++launchVersion;
    launching = true;
    clearTimeout(timer);
    try {
      await window.mamLoadShiprocket();
      if (!pageActive || version !== launchVersion) return;
      if (typeof window.shipRocketMarketingLogin !== 'function') throw new Error('Shiprocket login unavailable');
      window.shipRocketMarketingLogin();
    } catch (_) {
      if (pageActive && version === launchVersion) location.assign(accountUrl.href);
    } finally {
      if (pageActive && version === launchVersion) timer = setTimeout(() => { launching = false; }, 800);
    }
  }
  function owns(node) {
    if (node.matches('[data-mam-guest-track], [data-mam-account-page]')) return false;
    if (node.matches(explicit)) return true;
    if (!(node instanceof HTMLAnchorElement)) return false;
    let url;
    try { url = new URL(node.href, location.origin); } catch (_) { return false; }
    if (key(url) === key(accountUrl) || nativeRoutes.has(key(url))) return true;
    return url.origin === location.origin && /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/(?:account(?:\/(?:login|register))?|customer_authentication\/login)\/?$/i.test(url.pathname);
  }
  function prepare(node) {
    if (!owns(node)) return;
    node.setAttribute('data-mam-account-login', '');
    if (node instanceof HTMLAnchorElement && node.href !== accountUrl.href) node.href = accountUrl.href;
  }
  function scan(root) {
    if (!(root instanceof Element)) return;
    if (root.matches(selector)) prepare(root);
    root.querySelectorAll(selector).forEach(prepare);
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const node = event.target.closest(selector);
    if (!node || !owns(node)) return;
    prepare(node);
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (node instanceof HTMLAnchorElement && (node.target === '_blank' || node.hasAttribute('download'))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (launching || event.detail > 1) return;
    void launch();
  }, true);
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') prepare(record.target);
      else for (const node of record.addedNodes) scan(node);
    }
  });
  const observe = () => observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  scan(document.body);
  observe();
  window.addEventListener('pagehide', () => { pageActive = false; launchVersion += 1; observer.disconnect(); clearTimeout(timer); launching = false; });
  window.addEventListener('pageshow', event => { pageActive = true; if (event.persisted) { launching = false; scan(document.body); observe(); } });
})();


